
import React from 'react';
import {
  TipoColumnaMetadato, IMetadatoAsociado, IValorMetadato, $_,
  DATETIME_ERROR_STYLE, onFormatDate, DatePickerStrings,
  showError,
  defaultIMetadatoAsociado,
  ICategoriaMetadato, IOpcionSeleccionable,
  IContacto, _routes_, IService, DataTablesResponse, DataTableRequest, defaultIContacto, showWarnToast, ITipoColumnaMetadato
} from "./base";
import {
  IComboBoxOption, Icon, DatePicker,
  DayOfWeek, Checkbox, TextField,
  ComboBox, IContextualMenuItem, CommandBar,
  DetailsList, SelectionMode, DetailsListLayoutMode,
  ConstrainMode, Panel, PrimaryButton,
  DefaultButton, PanelType, Selection,
  Dropdown,
  IDropdownOption, ProgressIndicator, TooltipHost, DirectionalHint
} from "@fluentui/react";
import { EditorMetadatosComponent } from './components';
import { dateToStr } from '../../classes/utils';
import { GenericDataTableComponent } from 'ioip-base/lib/common';
import { ICity, ICountry, IDepartment } from '@ioip/archivox/lib';


////#endregion

export interface ILayoutEditorComponentProps {

  mode: 'edit' | 'exe';

  /**
   * Servicio web a utilizar para obtener los metadatos asociados al trámite, expediente o tipo documental
   * @param objectId Identificador del trámite, tipo documental o subserie
   */
  metadataService: (objectId: number) => Promise<IMetadatoAsociado[]>;

  /**
   * Método a ejecutar cuando se guarden cambios en los metadatos
   */
  onSaveMetadataService?: (values: IMetadatoAsociado[]) => Promise<void>;

  /**
   * Función a ejecutar cuando se cambie el valor de un metadato
   */
  onChangeValues: (values: IValorMetadato[]) => void;

  getCitiesService: () => Promise<ICity[]>;

  getDepartmentsService: () => Promise<IDepartment[]>;

  getCountriesService: () => Promise<ICountry[]>;

  getCategoryMetadataService: (name: string) => Promise<ICategoriaMetadato>;

  getMetadataOptionsService: (idMetadato: number) => Promise<IOpcionSeleccionable[]>;

  /**
   * Servicio a utilizar para la lectura de metadatos personalizados cuando son de tipo ExternalMetadata
   */
  readExternalMetadataService: (applicatin: string, className: string) => Promise<any[]>;

  /**
   * Servicio a utilizar para la lectura de metadatos personalizados
   */
  executeCustomCodeService: (applicatin: string, className: string, data: { [ key: string ]: any }) => Promise<string>;

  /**
   * Servicio encargado de consultar contactos
   */
  getContactsService: (request: DataTableRequest) => Promise<DataTablesResponse>;

  scope: 'fisico' | 'digital' | 'web';

  idObjeto: number;

  idObjetoAsUrlParam: boolean;

  getMetadataColumnTypes: () => Promise<ITipoColumnaMetadato[]>;

  values: IValorMetadato[];

  model: () => any;

}

export interface ILayoutEditorComponentState {
  values: IValorMetadato[];
  selectedItem: IMetadatoAsociado;
  metadata: IMetadatoAsociado[];
  cities: ICity[];
  departments: IDepartment[];
  countries: ICountry[];
  metadataCategories: { [ idMetadato: number ]: ICategoriaMetadato };
  metadataOptions: { [ idMetadato: number ]: IOpcionSeleccionable[] };
  customOptions: { [ idMetadato: number ]: IComboBoxOption[] };
  dynamic: {
    panel: {
      show: boolean;
      title: string;
      onClick?: () => void;
      values: IValorMetadato[];
      metadata: IMetadatoAsociado[];
      errors: { [ key: string ]: string };
    };
    commandBar: { [ key: string ]: IContextualMenuItem[] };
    selectedItem: { [ key: string ]: any[] };
    selection: { [ key: string ]: Selection };
  };
  /**
   * Almacena los errores de validación
   * key: IdMetadato
   * Value: Mensaje de error
   */
  errors: { [ key: number ]: string };
  contactsComponents: {
    show: boolean;
    onSelectedItem: (contact: IContacto) => void;
    selectedContact: IContacto;
    onAccept?: () => void;
  },
  isLoading: boolean;
  columnTypes: IComboBoxOption[];
  model: any;
}

export interface IMetadataRule {
  /**
        * Regla que evalua si se debe o no mostrar un mentadato en pantalla
        */
  _show?: (item: IMetadatoAsociado) => boolean;

  /**
   * Regla que se aplica al momento de renderizar un combobox y retorna los elementos a mostrar
   */
  _filter?: (item: IMetadatoAsociado, items: IComboBoxOption[]) => IComboBoxOption[];

  /**
   * Regla que evalua si un metadato es requierido o no
   */
  _required?: (item: IMetadatoAsociado) => boolean;

  /**
   * Función encargada de validar si un metadatos es valido
   * Aplica solo para metadatos complejos
   */
  _onValidateRequired?: (item: IMetadatoAsociado) => { isValid: boolean, message: string };

  /**
   * Función encargada de validar el formulario de metadatos anidado
   */
  _onValidateItem?: (item: IMetadatoAsociado, rowValues: any) => { [ key: number ]: string };

  _onOpenItemEditor?: (item: IMetadatoAsociado, panelMetadata: IMetadatoAsociado[]) => void;

  hasRequiredRule: boolean;
  hasShowRule: boolean;
  hasFilterRule: boolean;
  hasValidateRequiredRule: boolean;
  hasValidateItemRule: boolean;
  hasOpenItemEditor: boolean;

}

export class LayoutEditorComponent extends React.Component<ILayoutEditorComponentProps, ILayoutEditorComponentState>{

  /**
   * Identificador del trámite, subseries o tipo documental actual
   */
  private _objectId: number = 0;

  /**
   * Almacena los valores de los metadatos
   */
  private _values: IValorMetadato[] = [];

  /**
   * Almacena los metadatos asociados a los tramites
   * Key: ID trámite
   * Value: Metadatos asociados
   */
  private _tramites: { [ key: number ]: IMetadatoAsociado[] } = {};

  /**
   * Almacena las reglas compiladas de los metadatos
   * Key: ID metadato
   * Value: Reglas dinamicas
   */
  private _contexts: { [ key: number ]: IMetadataRule } = {}

  private _addButtonStyle: React.CSSProperties = {
    fontSize: '16px',
    'padding': '5px',
    'color': 'rgb(0, 120, 212)',
    'cursor': 'pointer',
    'border': '2px solid rgb(0, 120, 212)',
    borderRadius: '50%',
    boxShadow: 'rgb(177, 159, 159) 1px 3px 4px 0px',
    fontWeight: 'bold',
    display: 'block',
    'position': 'absolute',
    width: '31px',
    height: '31px',
    backgroundColor: 'white',
    zIndex: 1,
    paddingLeft: '6px',
    paddingTop: '1px',
    right: '4px',
    bottom: '-14px'
  };

  private _fieldCss: React.CSSProperties = {
    paddingTop: '2px',
    paddingLeft: '8px',
    border: '1px solid #BDBDBD',
    borderRadius: '3px',
    paddingBottom: '2px',
    marginBottom: '2px'
  }

  private _selectedContacts: { [ key: number ]: IContacto } = {}

  private _selectedDates: { [ key: number ]: Date } = {}

  private _editorMetadatosComponent: EditorMetadatosComponent;

  constructor(props: any) {
    super(props);
    this._objectId = this.props.idObjetoAsUrlParam
      ? Number((this.props as any).match.params.idObjeto)
      : this.props.idObjeto
    this.state = {
      values: [],
      metadata: [],
      selectedItem: defaultIMetadatoAsociado(),
      errors: {},
      cities: [],
      countries: [],
      departments: [],
      dynamic: this._defaultDynamic(),
      metadataCategories: {},
      metadataOptions: {},
      customOptions: {},
      contactsComponents: {
        onSelectedItem: undefined,
        show: false,
        selectedContact: defaultIContacto()
      },
      isLoading: false,
      columnTypes: [],
      model: {}
    }
  }

  private _defaultDynamic(): any {
    return {
      panel: {
        show: false,
        title: '',
        values: [],
        metadata: []
      },
      selectedItems: [],
      commandBar: {},
      selectedItem: {},
      selection: {}
    }
  }

  async componentDidMount(): Promise<void> {
    this.setState({ isLoading: true });
    await this._initAsync();
  }

  async componentWillReceiveProps(nextProps: ILayoutEditorComponentProps): Promise<void> {
    this._values = nextProps.values;
    if (nextProps.idObjeto !== this._objectId) {
      if (this.props.idObjetoAsUrlParam === false) {
        this._objectId = nextProps.idObjeto;
      }
      this.setState({ isLoading: true });
      await this._initAsync();
    } else {
      this.setState({ model: nextProps.model });
    }
  }

  private _compileDynamicFunction(item: IMetadatoAsociado): IMetadataRule {

    const $ = {
      array: (items: any[]) => {
        return {
          contains: (item: any) => items.indexOf(item) >= 0,
          notContains: (item: any) => items.indexOf(item) === -1
        }
      },
      cities: this.state.cities,
      mapCities: (filter: (item: ICity, index?: number) => boolean) => {
        return this.state.cities.filter(filter).map(o => ({ key: o.cityId, text: o.name }));
      },
      departments: this.state.departments,
      countries: this.state.countries,
      isNullOrEmpty: $_.isNullOrEmpty,
      upper: function (str: string) { return $.isNullOrEmpty(str) ? '' : str.toUpperCase(); },
      lower: function (str: string) { return $.isNullOrEmpty(str) ? '' : str.toLowerCase(); },
      trim: function (str: string) { return $.isNullOrEmpty(str) ? '' : str.trim(); },
      equal: function (a: any, b: any) { return a == b },
      notEqual: function (a: any, b: any) { return a != b },

      option: (codigoMetadato: string, text: string) => {
        const item = this.state.metadata.filter(o => o.Codigo.trim().toUpperCase() === $.upper($.trim(codigoMetadato)))[ 0 ];
        if (item === undefined) {
          return -1;
        }
        const items = this.state.customOptions[ item.IdMetadato ] || [];
        if (items.length > 0) {
          const opt = items.filter(o => o[ item.TextField || 'Text' ].trim().toUpperCase() === text.trim().toUpperCase())[ 0 ];
          if (opt !== undefined) {
            return opt[ item.KeyField || 'Key' ]
          }
        }
        return -1;
      },

      /**
       * Retorna el valor de un metadato
       */
      field: (key: string) => {
        const fields = this._getMetadataValues(false);
        const field = fields[ key ];
        if (field === undefined) {
          throw new Error(`Error: El campo '${key}' no se encontró`)
        }
        return field;
      },
      /**
       * Retorna el id una lista desplegable
       */
      id: (key: string) => {
        const fields = this._getMetadataValues(true);
        const field = fields[ key ];
        if (field === undefined) {
          throw new Error(`Error: El campo '${key}' no se encontró`)
        }
        return field;
      },

      getValues: () => {
        return this._values;
      },

      /**
       * Retorna el ID del trámite, tipo documental o subserie actual
       */
      getObjectId: () => {
        return this._objectId;
      },

      setPanelMetadataRequired: (panelMetadata: IMetadatoAsociado[], matadataCode: string, required: boolean) => {
        if (panelMetadata) {
          var item = panelMetadata.filter(o => o.Codigo === matadataCode)[ 0 ];
          if (item) {
            item.Requerido = required
          }
          else {
            throw new Error(`Error al establecer el valor de la propiedad requerido: No se encontró el metadato '${matadataCode}'`);
          }
        }
      },

      getModel: () => {
        if (this.state.model) {
          return this.state.model();
        }
        return {};
      },

      scope: this.props.scope

    };

    const func = new Function('$', '__item__', `
        var
          upper = $.upper,
          lower = $.lower,
          equal = $.equal,
          notEqual = $.notEqual,
          field = $.field,
          id = $.id,
          SI = true,
          NO = false,
          trim = $.trim,
          option = $.option,
          SCOPE = $.scope;
        
          ${item.Reglas};

          $._filter = function(item, options) {
            if ($.filter !== undefined && typeof $.filter === 'function') {
              return $.filter(item, options);
            }
            return options;
          }

          $._show = function(item) {
            if ($.show !== undefined && typeof $.show === 'function') {
              try {
                return $.show(item);
              } catch (ex){
                console.log('Error al ejecutar la regla show del metadato ' + __item__, ex.message);
              }
            }
            return true;
          }

          $._required = function(item) {
            if ($.required !== undefined && typeof $.required === 'function') {
              try {
                return $.required(item);
              } catch (ex){
                console.log('Error al ejecutar la regla required del metadato ' + __item__, ex.message);
              }
            }
            return false;
          }

          $._onValidateRequired = function(item) {
            if ($.onValidateRequired !== undefined && typeof $.onValidateRequired === 'function') {
              try {
                var values = $.getValues();
                return $.onValidateRequired(item, values);
              } catch (ex){
                console.log('Error al ejecutar la regla onValidateRequired del metadato ' + __item__, ex.message);
              }
            }
            return { error: false };
          }

          $._onValidateItem = function(item, rowValues) {
            if ($.onValidateItem !== undefined && typeof $.onValidateItem === 'function') {
              try {
                return $.onValidateItem(item, rowValues);
              } catch (ex){
                console.log('Error al ejecutar la regla onValidateItem del metadato ' + __item__, ex.message);
              }
            }
            return { };
          }

          $._onOpenItemEditor = function(item, panelMetadata) {
            if ($.onOpenItemEditor !== undefined && typeof $.onValidateItem === 'function') {
              try {
                function _setPanelMetadataRequired(codigo, requerido) {
                  $.setPanelMetadataRequired(panelMetadata, codigo, requerido);
                }
                return $.onOpenItemEditor(JSON.parse(JSON.stringify(item)), JSON.parse(JSON.stringify(panelMetadata)), _setPanelMetadataRequired);
              } catch (ex){
                console.log('Error al ejecutar la regla onOpenItemEditor del metadato ' + __item__, ex.message);
              }
            }
          }

          return $;

      `);

    const compiledRules = func($, item.Nombre);
    return compiledRules;

  }

  private async _initAsync(): Promise<void> {

    // Limpiar variables
    this._contexts = {};

    if (this._objectId > 0) {

      let columnTypes = this.state.columnTypes;
      if (this.props.mode === 'edit') {
        if (this.state.columnTypes.length === 0) {
          const result = await this.props.getMetadataColumnTypes();
          columnTypes = result.map(o => ({ key: o.IdTipoColumnaMetadato, text: o.Nombre }))
        }
      }

      // Obtener los metadatos asociados al trámite seleccionado
      const metadata: IMetadatoAsociado[] = this._tramites[ this._objectId ] !== undefined
        ? this._tramites[ this._objectId ]
        : await this.props.metadataService(this._objectId);

      // Compilar funciones dinamicas de las reglas
      if (this.props.mode === 'exe') {
        if (metadata !== undefined && metadata.length > 0) {
          for (let i = 0; i < metadata.length; i++) {
            const item = metadata[ i ];
            if (!$_.isNullOrEmpty(item.Reglas)) {
              this._contexts[ item.IdMetadato ] = this._compileDynamicFunction(item);
              this._contexts[ item.IdMetadato ].hasFilterRule = (this._contexts[ item.IdMetadato ] as any).filter !== undefined;
              this._contexts[ item.IdMetadato ].hasRequiredRule = (this._contexts[ item.IdMetadato ] as any).required !== undefined;
              this._contexts[ item.IdMetadato ].hasShowRule = (this._contexts[ item.IdMetadato ] as any).show !== undefined;
              this._contexts[ item.IdMetadato ].hasValidateItemRule = (this._contexts[ item.IdMetadato ] as any).onValidateItem !== undefined;
              this._contexts[ item.IdMetadato ].hasValidateRequiredRule = (this._contexts[ item.IdMetadato ] as any).onValidateRequired !== undefined;
              this._contexts[ item.IdMetadato ].hasOpenItemEditor = (this._contexts[ item.IdMetadato ] as any).onOpenItemEditor !== undefined;
              item.Reglas = '';
            }
          }
        }
      }

      // Agregar metadato inicial
      if (this.props.mode === 'edit') {
        if (metadata.length === 0) {
          metadata.push(defaultIMetadatoAsociado());
        }
      }

      // Descargar datos del servidor
      let cities: ICity[] = this.state.cities;
      let departments: IDepartment[] = this.state.departments;
      let countries: ICountry[] = this.state.countries;
      const complexItems = metadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Metadato);
      const itemsTypeSeleccion = metadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Seleccion);
      const customTypeItems = metadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Custom || o.IdTipoColumnaMetadato === TipoColumnaMetadato.CustomMultiSeleccion);
      const commandBar = this.state.dynamic.commandBar;
      const selectedItem = this.state.dynamic.selectedItem;
      const selection = this.state.dynamic.selection;
      const metadataCategories = this.state.metadataCategories;
      const metadataOptions = this.state.metadataOptions;
      const customOptions = this.state.customOptions;

      if (this.props.mode === 'exe') {

        let loadCountries = metadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Pais).length > 0 && countries.length === 0;
        let loadDepartments = metadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Departamento).length > 0 && departments.length === 0;
        let loadCities = metadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Ciudad).length > 0 && cities.length === 0;

        const result = await Promise.all([
          loadCountries ? this.props.getCountriesService() : new Promise<ICountry[]>(resolve => resolve(countries)),
          loadDepartments ? this.props.getDepartmentsService() : new Promise<IDepartment[]>(resolve => resolve(departments)),
          loadCities ? this.props.getCitiesService() : new Promise<ICity[]>(resolve => resolve(cities)),
        ]);

        countries = result[ 0 ];
        departments = result[ 1 ] as any;
        cities = result[ 2 ];

        // Validar si existen campos de tipo Metadato
        if (complexItems.length > 0) {

          for (let i = 0; i < complexItems.length; i++) {

            const item = complexItems[ i ];

            // Descargar configuración de la categoria metadato - hijo
            if (metadataCategories[ item.NombreCategoriaMetadato ] === undefined) {
              metadataCategories[ item.NombreCategoriaMetadato ] = await this.props.getCategoryMetadataService(item.NombreCategoriaMetadato);
              // Descargar opciones de listas desplegables
              const complexMetadata: IMetadatoAsociado[] = metadataCategories[ item.NombreCategoriaMetadato ].Metadatos;
              const complexItemsTypeSeleccion = complexMetadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Seleccion);
              if (complexItemsTypeSeleccion.length > 0) {
                complexItemsTypeSeleccion.forEach(o => {
                  if (itemsTypeSeleccion.filter(p => o.IdMetadato === p.IdMetadato).length === 0) {
                    itemsTypeSeleccion.push(o);
                  }
                });
              }
              const complexCustomTypeItems = complexMetadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Custom || o.IdTipoColumnaMetadato === TipoColumnaMetadato.CustomMultiSeleccion);
              if (complexCustomTypeItems.length > 0) {
                complexCustomTypeItems.forEach(o => {
                  if (customTypeItems.filter(p => o.IdMetadato === p.IdMetadato).length === 0) {
                    customTypeItems.push(o);
                  }
                });
              }
            }

            // Crear el comand-bar
            commandBar[ item.IdMetadato ] = this._buildDynamicCommandBar(item, []);

            selectedItem[ item.IdMetadato ] = [];

            selection[ item.IdMetadato ] = new Selection({
              onSelectionChanged: () => {
                const selectedItems = this.state.dynamic.selection[ item.IdMetadato ].getSelection();
                this.setState({
                  dynamic: {
                    ...this.state.dynamic,
                    commandBar: {
                      ...this.state.dynamic.commandBar,
                      [ item.IdMetadato ]: this._buildDynamicCommandBar(item, selectedItems)
                    },
                    selectedItem: {
                      ...this.state.dynamic.selectedItem,
                      [ item.IdMetadato ]: selectedItems
                    }
                  }
                });
              }
            });

          }
        }

        // Descargar opciones de metadato
        if (itemsTypeSeleccion.length > 0) {
          for (let i = 0; i < itemsTypeSeleccion.length; i++) {
            const item = itemsTypeSeleccion[ i ];
            if (metadataOptions[ item.IdMetadato ] === undefined || metadataOptions[ item.IdMetadato ].length === 0) {
              metadataOptions[ item.IdMetadato ] = await this.props.getMetadataOptionsService(item.IdMetadato);
            }
          }
        }
        // Descargar opciones de metadatos tipo CUSTOM
        if (customTypeItems.length > 0) {
          for (let i = 0; i < customTypeItems.length; i++) {
            const item = customTypeItems[ i ];
            if (customOptions[ item.IdMetadato ] === undefined || customOptions[ item.IdMetadato ].length === 0) {
              if ($_.isNullOrEmpty(item.KeyField) || item.KeyField === 'Key') {
                let result = undefined;
                try {
                  result = await this.props.readExternalMetadataService(item.Aplicacion, item.ClassName);
                } catch (error) {
                  throw Error(`Error al leer los valores del metadato externo ${item.Nombre} de la categoría ${item.CategoriaMetadato}`);
                }
                if (result != null) {
                  customOptions[ item.IdMetadato ] = result;
                } else {
                  customOptions[ item.IdMetadato ] = [];
                }
              } else {
                let result = undefined;
                try {
                  result = await this.props.executeCustomCodeService(item.Aplicacion, item.ClassName, {})
                } catch (error) {
                  throw Error(`Error al ejecutar la extensión ${item.ClassName} (${item.Aplicacion}) del metadato ${item.Nombre} de la categoría ${item.CategoriaMetadato}`);
                }
                const obj = JSON.parse(result);
                if (obj != null) {
                  customOptions[ item.IdMetadato ] = obj;
                } else {
                  customOptions[ item.IdMetadato ] = [];
                }
              }
            }
          }
        }

        // Inicializar campos tipo contacto
        metadata.filter(o => [ TipoColumnaMetadato.Contactos, TipoColumnaMetadato.ContactosEntidades, TipoColumnaMetadato.ContactosPersonas ].indexOf(o.IdTipoColumnaMetadato) >= 0).forEach(o => {
          this._selectedContacts[ o.IdMetadato ] = defaultIContacto();
        });

      }

      this._tramites[ this._objectId ] = metadata;

      this.setState({
        metadata,
        cities,
        countries,
        departments,
        dynamic: {
          ...this.state.dynamic,
          commandBar,
          selectedItem
        },
        metadataCategories,
        metadataOptions,
        customOptions,
        isLoading: false,
        columnTypes
      });
    }

  }

  public render(): JSX.Element {
    return <div>
      {
        this.props.idObjeto > 0 && this.state.isLoading
          ? <ProgressIndicator label="Cargando formulario" description="Por favor espere un momento mientras se de carga el formulario del trámite seleccionado" />
          : this._renderBody()
      }
    </div>
  }

  private _renderBody(): JSX.Element {

    const fields = this.state.metadata.map((o, index) => { o.Orden = index; return o });
    const rows = this._processFields(fields);

    return <div>
      <div className='ms-Grid'>
        <div className='md-Grid-row'>
          <div className={`ms-Grid-col ms-u-sm${this.props.mode === 'edit' ? '6' : '12'}`} style={{ padding: '8px' }}>
            <div className='ms-Grid'>
              <div className='ms-Grid-row' style={{ marginTop: '10px' }} >
                {
                  rows.map((o, index: number) => {
                    return { ...o, key: index };
                  })
                }
              </div>
            </div>
          </div>
        </div>
        {
          this.props.mode === 'edit' && <div className='md-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12'>
              <DefaultButton
                text='Guardar'
                onClick={() => {
                  try {
                    if (this.state.metadata.filter(o => o.IdMetadato === 0).length === 0) {
                      this.props.onSaveMetadataService(this.state.metadata);
                    } else {
                      showWarnToast('Existen campos que no se han parametrizado');
                    }
                  } catch (err) {
                    if (err instanceof Error) {
                      showError(err.message);
                    }
                  }
                }}
              />
            </div>
          </div>
        }
      </div>
      {
        this._renderComplexPanel()
      }
      {
        this._renderContactPanel()
      }
    </div>
  }

  private _renderComplexPanel(): JSX.Element {
    return <Panel
      isOpen={this.state.dynamic.panel.show}
      type={PanelType.largeFixed}
      headerText={this.state.dynamic.panel.title}
      hasCloseButton={false}
      onRenderFooterContent={() => <div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'right' }}>
            <PrimaryButton
              text='Agregar'
              onClick={() => {
                this.state.dynamic.panel.onClick();
              }}
            />
            <span>&nbsp;&nbsp;</span>
            <DefaultButton
              text='Volver'
              onClick={() => {
                this.setState({
                  dynamic: {
                    ...this.state.dynamic,
                    panel: {
                      ...this.state.dynamic.panel,
                      show: false
                    }
                  }
                });
              }}
            />
          </div>
        </div>
      </div>}
      isFooterAtBottom={true}>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
          {
            this.state.dynamic.panel.show && <EditorMetadatosComponent
              metadatos={this.state.dynamic.panel.metadata}
              searchMode={false}
              renderOnlyItemsMarkAsShow={false}
              values={this.state.dynamic.panel.values}
              errors={this.state.dynamic.panel.errors}
              onChangeErrors={(errors: { [ key: string ]: string }) => {
                this.setState({
                  dynamic: {
                    ...this.state.dynamic,
                    panel: {
                      ...this.state.dynamic.panel,
                      errors
                    }
                  }
                });
              }}
              onChangeValues={(values: IValorMetadato[]) => {
                this.setState({
                  dynamic: {
                    ...this.state.dynamic,
                    panel: {
                      ...this.state.dynamic.panel,
                      values
                    },
                  }
                });
              }}
              ref={e => this._editorMetadatosComponent = e}
            />
          }
        </div>
      </div>
    </Panel>
  }

  private _renderContactPanel(): JSX.Element {
    return <Panel
      isOpen={this.state.contactsComponents.show}
      type={PanelType.largeFixed}
      headerText={'Buscar contactos'}
      hasCloseButton={false}
      onRenderFooterContent={() => <div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12' style={{ textAlign: 'right' }}>
            {
              this.state.contactsComponents.selectedContact.IdContacto > 0 && <PrimaryButton
                text='Agregar'
                onClick={() => {
                  if (this.state.contactsComponents.onAccept) {
                    this.state.contactsComponents.onAccept();
                  }
                }}
              />
            }
            {
              this.state.contactsComponents.selectedContact.IdContacto > 0 && <span>&nbsp;&nbsp;</span>
            }
            <DefaultButton
              text='Volver'
              onClick={() => {
                this.setState({
                  contactsComponents: {
                    show: false,
                    onSelectedItem: undefined,
                    selectedContact: defaultIContacto()
                  }
                });
              }}
            />
          </div>
        </div>
      </div>}
      isFooterAtBottom={true}>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
          <ContactosComponent
            mode='embebed'
            onSelectedItem={this.state.contactsComponents.onSelectedItem}
            service={{
              paginateAsync: this.props.getContactsService
            } as any}
            serviceMethodName='paginateAsync'
          />
        </div>
      </div>
    </Panel>
  }

  //#region Renderizado edición

  private _renderEditFieldControl(item: IMetadatoAsociado): JSX.Element {
    switch (item.IdTipoColumnaMetadato) {

      case TipoColumnaMetadato.Texto:
        return <TextField
          label={item.Nombre}
          disabled={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.ExpresionRegular:
        return <TextField
          label={item.Nombre}
          disabled={true}
          multiline={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.Numero:
        return <TextField
          label={item.Nombre}
          disabled={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.Moneda:
        return <TextField
          label={item.Nombre}
          disabled={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.Fecha:
        return <TextField
          label={item.Nombre}
          disabled={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.Nota:
        return <TextField
          label={item.Nombre}
          disabled={true}
          multiline={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.Seleccion:
      case TipoColumnaMetadato.Usuario:
      case TipoColumnaMetadato.Pais:
      case TipoColumnaMetadato.Departamento:
      case TipoColumnaMetadato.Ciudad:
      case TipoColumnaMetadato.Custom:
        return <ComboBox
          label={item.Nombre}
          options={[]}
          disabled={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.CustomMultiSeleccion:
        return <TextField
          label={item.Nombre}
          disabled={true}
          required={item.Requerido}
        />;

      case TipoColumnaMetadato.SiNo:
        return <Checkbox
          label={item.Nombre}
          disabled={true}
        />;

      case TipoColumnaMetadato.Metadato:
        return this._renderEditMultipleField(item);

      case TipoColumnaMetadato.Contactos:
      case TipoColumnaMetadato.ContactosEntidades:
      case TipoColumnaMetadato.ContactosPersonas:
        return <TextField
          label={item.Nombre}
          disabled={true}
          required={item.Requerido}
          value='Contactos'
        />;

      default:
        return <div style={{ padding: '8px 1px', color: 'red' }}>
          Debe seleccionar un metadato
        </div>;
    }
  }

  private _renderEditMultipleField(item: IMetadatoAsociado): JSX.Element {
    return <div>
      <DetailsList
        items={[
          { Col1: 'Dato', Col2: 'Dato', Col3: 'Dato' },
          { Col1: 'Dato', Col2: 'Dato', Col3: 'Dato' },
          { Col1: 'Dato', Col2: 'Dato', Col3: 'Dato' }
        ]}
        compact={true}
        columns={[
          {
            key: 'Col1',
            name: 'Col1',
            fieldName: 'Col1',
            minWidth: 100,
            maxWidth: 150,
          },
          {
            key: 'Col2',
            name: 'Col2',
            fieldName: 'Col2',
            minWidth: 100,
            maxWidth: 150,
          },
          {
            key: 'Col3',
            name: 'Col3',
            fieldName: 'Col3',
            minWidth: 100,
            maxWidth: 150,
          }
        ]}
        selectionMode={SelectionMode.none}
        isHeaderVisible={true}
        layoutMode={DetailsListLayoutMode.fixedColumns}
        constrainMode={ConstrainMode.horizontalConstrained}
      />
    </div>
  }

  ////#endregion

  private _renderExecutableFieldControl(item: IMetadatoAsociado): JSX.Element {
    switch (item.IdTipoColumnaMetadato) {
      case TipoColumnaMetadato.Texto:
      case TipoColumnaMetadato.Nota:
        return this._renderExecutableText(item);
      case TipoColumnaMetadato.ExpresionRegular:
      case TipoColumnaMetadato.Numero:
      case TipoColumnaMetadato.Moneda:
        return this._renderExecutableText(item);
      case TipoColumnaMetadato.Fecha:
        return this._renderExecutableDate(item);
      case TipoColumnaMetadato.Seleccion:
      case TipoColumnaMetadato.Usuario:
      case TipoColumnaMetadato.Pais:
      case TipoColumnaMetadato.Departamento:
      case TipoColumnaMetadato.Ciudad:
      case TipoColumnaMetadato.Custom:
        return this._renderExecutableComboBox(item);
      case TipoColumnaMetadato.CustomMultiSeleccion:
        return this._renderExecutableMultiSelect(item);
      case TipoColumnaMetadato.SiNo:
        return this._renderExecutableBoolean(item);
      case TipoColumnaMetadato.Metadato:
        return this._renderExecutableMetadata(item);
      case TipoColumnaMetadato.Contactos:
      case TipoColumnaMetadato.ContactosEntidades:
      case TipoColumnaMetadato.ContactosPersonas:
        return this._renderExecutableContactSearch(item);
      default:
        return <div>Debe seleccionar un metadato</div>;
    }
  }

  public _renderExecutableComboBox(item: IMetadatoAsociado): JSX.Element {

    // Obtener valor seleccionado
    const selectedKey: number = Number(this._getValue<string>(item));

    // Obtener fuente de datos
    item.Opciones = this._getExecutableComboBoxOptions(item);

    // Filtrar elementos
    if (this._contexts[ item.IdMetadato ] !== undefined) {
      item.Opciones = this._contexts[ item.IdMetadato ]._filter(item, item.Opciones);
    }

    // Establecer si el elemento es o no requierido
    const required = this._isRequired(item);

    return <ComboBox
      label={item.Nombre}
      required={required}
      useComboBoxAsMenuWidth={true}
      autoComplete='on'
      errorMessage={this.state.errors[ item.IdMetadato ]}
      selectedKey={selectedKey}
      options={item.Opciones}
      onChange={(ev: any, value: IComboBoxOption) => this._setValue(item, value.key)}
    />;

  }

  public _renderExecutableText(item: IMetadatoAsociado): JSX.Element {

    // Establecer si el elemento es o no requierido
    const required = this._isRequired(item);

    return <TextField
      label={item.Nombre}
      required={required}
      maxLength={item.LongitudMaxima || 1024}
      value={this._getValue<string>(item)}
      multiline={item.IdTipoColumnaMetadato === TipoColumnaMetadato.Nota}
      errorMessage={this.state.errors[ item.IdMetadato ]}
      onChange={(_, value) => this._setValue(item, value)}
    />;

  }

  public _renderExecutableBoolean(item: IMetadatoAsociado): JSX.Element {
    return <div style={{ paddingTop: '8px' }}>
      <Checkbox
        label={item.Nombre}
        checked={this._getValue<boolean>(item)}
        onChange={(event, value) => {
          this._setValue(item, value);
        }}
      />
    </div>;
  }

  public _renderExecutableDate(item: IMetadatoAsociado): JSX.Element {
    const value = this._getValue<Date>(item, true);
    return <div>
      <DatePicker
        firstDayOfWeek={DayOfWeek.Sunday}
        strings={DatePickerStrings}
        placeholder='dd/MM/yyyy'
        isRequired={item.Requerido}
        label={item.Nombre}
        formatDate={onFormatDate}
        onSelectDate={(value: Date) => {
          this._selectedDates[ item.IdMetadato ] = value;
          this._setValue(item, value);
        }}
        value={value}
      />
      <small style={DATETIME_ERROR_STYLE}>{this.state.errors[ item.IdMetadato ]}</small>
    </div>
  }

  private _updateExecutableMetadatoFieldValues(item: IMetadatoAsociado, selectedItem: any): any {

    // Obtener valor del metadato actual o crearlo
    const _value = this._values.filter(o => o.IdMetadato === item.IdMetadato)[ 0 ];
    const _rows = (_value !== undefined && _value.Valor !== undefined) ? _value.Valor : [];

    // Obtener los valores del panel de metadatos
    const panelData: { [ key: string ]: string } = {};
    this.state.dynamic.panel.values.forEach(p => {
      const metadata = this.state.dynamic.panel.metadata.filter(o => o.IdMetadato === p.IdMetadato)[ 0 ];
      if (!(p.Valor instanceof Date)) {
        panelData[ metadata.Nombre ] = p.Valor;
        panelData[ p.IdMetadato ] = p.Valor;
      } else {
        //const value = '';
        panelData[ metadata.Nombre ] = p.Valor.toLocaleString();
        panelData[ p.IdMetadato ] = p.Valor.toISOString();
      }
    });

    // Evaluar las reglas personalizadas
    const rules = this._contexts[ item.IdMetadato ];
    if (rules !== undefined) {
      const result = rules._onValidateItem(item, panelData);
      const props = Object.getOwnPropertyNames(result);
      if (props.length > 0) {

        // Obtener los ID de los metadatos filtrando por el nombre
        for (let i = 0; i < props.length; i++) {
          const tmp = this.state.dynamic.panel.metadata.filter(o => o.Nombre === props[ i ])[ 0 ];
          if (tmp !== undefined) {
            result[ tmp.IdMetadato ] = result[ props[ i ] ];
          }
        }

        this.setState({
          dynamic: {
            ...this.state.dynamic,
            panel: {
              ...this.state.dynamic.panel,
              errors: result
            }
          }
        });
        return;
      }
    }


    // Si no hay un elemento seleccionado quiere decir que el elemento es nuevo
    // y por lo tanto se debe agregar a la colección, de lo contrario se debe remplazar
    // el elemento seleccionado por el nuevo elemento
    if (selectedItem === undefined) {
      _rows.push(panelData);
    } else {
      _rows[ selectedItem.___index ] = panelData;
    }

    // Agregar indice a los elementos
    _rows.forEach((o: any, index: number) => o.___index = index);

    this.setState({
      dynamic: {
        ...this.state.dynamic,
        panel: {
          ...this.state.dynamic.panel,
          show: false
        },
        selectedItem: {
          ...this.state.dynamic.selectedItem,
          [ item.IdMetadato ]: []
        }
      }
    }, () => this._setValue(item, _rows));

    // Quitar la selección de elementos
    this.state.dynamic.selection[ item.IdMetadato ].setAllSelected(false);

  }

  public _buildDynamicCommandBar(item: IMetadatoAsociado, selectedItems: any[]) {

    const items: IContextualMenuItem[] = [ {
      key: 'Nuevo',
      name: 'Nuevo',
      iconProps: { iconName: 'Add' },
      title: 'Crear nuevo elemento',
      onClick: () => {

        // Obtener metadatos a mostrar en el panel de edición
        const subCategory = this.state.metadataCategories[ item.NombreCategoriaMetadato ];
        const complexMetadata: IMetadatoAsociado[] = subCategory.Metadatos;
        const complexItemsTypeSeleccion = complexMetadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Seleccion);
        if (complexItemsTypeSeleccion.length > 0) {
          complexItemsTypeSeleccion.forEach(o => {
            const options = this.state.metadataOptions[ o.IdMetadato ] || [];
            o.Opciones = options.map(o => ({ key: o.IdOpcionListaDesplegableMetadato, text: o.Nombre }));
          });
        }
        const complexCustomTypeItems = complexMetadata.filter(o => o.IdTipoColumnaMetadato === TipoColumnaMetadato.Custom || o.IdTipoColumnaMetadato === TipoColumnaMetadato.CustomMultiSeleccion);
        if (complexCustomTypeItems.length > 0) {
          complexCustomTypeItems.forEach(o => {
            const options = this.state.customOptions[ o.IdMetadato ] || [];
            o.Opciones = options.map(o => ({
              key: o[ item.KeyField || 'Key' ],
              text: o[ item.TextField || 'Text' ]
            }))
          });
        }

        const panelMetadata = subCategory !== null && subCategory.Metadatos != null ? subCategory.Metadatos : [];

        // Ejecuta regla onOpenItemEditor
        const rules = this._contexts[ item.IdMetadato ];
        if (rules !== undefined) {
          rules._onOpenItemEditor(item, panelMetadata);
        }

        this.setState({
          dynamic: {
            ...this.state.dynamic,
            panel: {
              show: true,
              title: 'Agregar elemento',
              metadata: panelMetadata,
              values: [],
              onClick: this._updateExecutableMetadatoFieldValues.bind(this, item) as any,
              errors: {}
            }
          }
        });
      }
    } ];

    if (selectedItems.length) {

      items.push({
        key: 'Editar',
        name: 'Editar',
        iconProps: { iconName: 'Edit' },
        onClick: () => {
          // Obtener valor del metadato actual
          const obj = selectedItems[ 0 ];
          const values = [];
          if (obj) {
            for (const key in obj) {
              if (obj.hasOwnProperty(key)) {
                if (!isNaN(Number(key))) {
                  values.push({
                    IdMetadato: Number(key),
                    Valor: obj[ key ]
                  });
                }
              }
            }
          }
          const subCategory = this.state.metadataCategories[ item.NombreCategoriaMetadato ];
          this.setState({
            dynamic: {
              ...this.state.dynamic,
              panel: {
                show: true,
                title: 'Editar elemento',
                metadata: subCategory !== null && subCategory.Metadatos != null ? subCategory.Metadatos : [],
                values,
                onClick: this._updateExecutableMetadatoFieldValues.bind(this, item, selectedItems[ 0 ]),
                errors: {}
              }
            }
          });
        }
      });

      items.push({
        key: 'Eliminar',
        name: 'Eliminar',
        iconProps: { iconName: 'Delete' },
        onClick: () => {
          const _value = this._values.filter(o => o.IdMetadato === item.IdMetadato)[ 0 ];
          _value.Valor.splice(selectedItems[ 0 ].___index, 1);
          _value.Valor.forEach((o: any, index: number) => o.___index = index);
          this._setValue(item, _value.Valor);
          this.setState({
            dynamic: {
              ...this.state.dynamic,
              selectedItem: {
                ...this.state.dynamic.selectedItem,
                [ item.IdMetadato ]: []
              }
            }
          });
        }
      });

    }
    return items;
  }

  public _renderExecutableMetadata(item: IMetadatoAsociado): JSX.Element {
    const category = this.state.metadataCategories[ item.NombreCategoriaMetadato ];
    if ($_.isNull(category)) {
      return <div>No se ha encontrado la categoria de metadato '{item.NombreCategoriaMetadato}'</div>
    }

    // Obtener columnas a mostrar
    const columns = category.Metadatos.map(o => ({
      key: o.Nombre,
      name: o.Nombre,
      fieldName: o.Nombre,
      minWidth: 150,
      maxWidth: 220,
      isResizable: true,
      onRender: (o) => {
        console.log(o);
        return o.Nombre;
      }
    }));

    // Obtener el valor del metadato
    const metadatoValues = this._values.filter(o => o.IdMetadato == item.IdMetadato)[ 0 ];

    return <div>
      <p className="ms-fontSize-l ms-fontColor-themePrimary">{item.Nombre}</p>
      <CommandBar
        items={this.state.dynamic.commandBar[ item.IdMetadato ]}
        className={'command-bar-1'}
      />
      <DetailsList
        items={metadatoValues != null && metadatoValues.Valor ? metadatoValues.Valor : []}
        compact={true}
        columns={columns}
        selectionMode={SelectionMode.single}
        isHeaderVisible={true}
        layoutMode={DetailsListLayoutMode.fixedColumns}
        constrainMode={ConstrainMode.horizontalConstrained}
        selection={this.state.dynamic.selection[ item.IdMetadato ]}
      />
      <small style={DATETIME_ERROR_STYLE}>{this.state.errors[ item.IdMetadato ]}</small>
    </div>
  }

  private _renderExecutableMultiSelect(item: IMetadatoAsociado): JSX.Element {

    // Obtener los valores seleccionados
    const selectedKeys: number[] = this._getValue<any>(item) || [];

    // Obtener fuente de datos
    item.Opciones = this._getExecutableComboBoxOptions(item);

    const required = this._isRequired(item);

    return <Dropdown
      label={item.Nombre}
      selectedKeys={selectedKeys}
      required={required}
      onChanged={(option: IDropdownOption) => {
        const _option = selectedKeys.filter(o => o === Number(option.key))[ 0 ];
        if (_option === undefined) {
          selectedKeys.push(Number(option.key))
        } else {
          if (!option.selected) {
            selectedKeys.splice(selectedKeys.indexOf(_option), 1)
          }
        }
        this._setValue(item, selectedKeys);
      }}
      multiSelect
      errorMessage={this.state.errors[ item.IdMetadato ]}
      options={item.Opciones}
    />;
  }

  public _renderExecutableContactSearch(item: IMetadatoAsociado): JSX.Element {

    // Establecer si el elemento es o no requierido
    const required = this._isRequired(item);

    const text = this._selectedContacts[ item.IdMetadato ] !== undefined && this._selectedContacts[ item.IdMetadato ].IdContacto > 0
      ? this._selectedContacts[ item.IdMetadato ].Nombres + this._selectedContacts[ item.IdMetadato ].Apellidos
      : 'Haga clic aquí para seleccionar un contacto';

    return <TextField
      label={item.Nombre}
      required={required}
      value={text}
      errorMessage={this.state.errors[ item.IdMetadato ]}
      readOnly={true}
      onChange={(_, value) => this._setValue(item, value)}
      onClick={() => {
        this.setState({
          contactsComponents: {
            show: true,
            onSelectedItem: (contact: IContacto) => {
              this.setState({
                contactsComponents: {
                  ...this.state.contactsComponents,
                  selectedContact: contact || defaultIContacto()
                }
              })
            },
            selectedContact: defaultIContacto(),
            onAccept: () => {
              this._selectedContacts[ item.IdMetadato ] = this.state.contactsComponents.selectedContact;
              this.setState({
                contactsComponents: {
                  show: false,
                  onSelectedItem: undefined,
                  selectedContact: defaultIContacto()
                }
              }, () => this._setValue(item, this._selectedContacts[ item.IdMetadato ].IdContacto));
            }
          }
        });
      }}
    />;

  }


  //#region Utilidades

  private _getValue<T>(item: IMetadatoAsociado, useDate: boolean = false): T {
    if (this._values === undefined || this._values === null) {
      this._values = [];
    }
    let value: IValorMetadato = this._values.filter(o => o.IdMetadato === item.IdMetadato)[ 0 ];
    if (value !== undefined) {
      if (item.IdTipoColumnaMetadato == TipoColumnaMetadato.Fecha) {
        if (useDate) {
          return this._selectedDates[ item.IdMetadato ] as any;
        }
        else {
          return value.Valor as any;
        }
      } else {
        return (value.Valor as any) as T;
      }
    } else {
      switch (item.IdTipoColumnaMetadato) {
        case TipoColumnaMetadato.Texto:
        case TipoColumnaMetadato.ExpresionRegular:
        case TipoColumnaMetadato.Nota:
        case TipoColumnaMetadato.Fecha:
          return '' as any;
        case TipoColumnaMetadato.Numero:
        case TipoColumnaMetadato.Moneda:
        case TipoColumnaMetadato.Seleccion:
        case TipoColumnaMetadato.Usuario:
        case TipoColumnaMetadato.Pais:
        case TipoColumnaMetadato.Departamento:
        case TipoColumnaMetadato.Ciudad:
        case TipoColumnaMetadato.Custom:
        case TipoColumnaMetadato.CustomMultiSeleccion:
        case TipoColumnaMetadato.Contactos:
        case TipoColumnaMetadato.ContactosEntidades:
        case TipoColumnaMetadato.ContactosPersonas:
          return 0 as any;
        case TipoColumnaMetadato.SiNo:
          return false as any;
        case TipoColumnaMetadato.Metadato:
          return {} as any;
      }
    }
    return undefined;
  }

  private _getExecutableComboBoxOptions(item: IMetadatoAsociado): IComboBoxOption[] {
    switch (item.IdTipoColumnaMetadato) {
      case TipoColumnaMetadato.Pais:
        return this.state.countries.map(o => ({ key: o.countryId, text: o.name }));
      case TipoColumnaMetadato.Departamento:
        return this.state.departments.map(o => ({ key: o.departmentId, text: o.name }));
      case TipoColumnaMetadato.Ciudad:
        return this.state.cities.map(o => ({ key: o.cityId, text: o.name }));
      case TipoColumnaMetadato.Seleccion:
        return this.state.metadataOptions[ item.IdMetadato ] !== undefined ?
          this.state
            .metadataOptions[ item.IdMetadato ]
            .map(o => ({ key: o.IdOpcionListaDesplegableMetadato, text: o.Nombre }))
          : [];
      case TipoColumnaMetadato.Custom:
      case TipoColumnaMetadato.CustomMultiSeleccion:
        return this.state.customOptions[ item.IdMetadato ] !== undefined ?
          this.state
            .customOptions[ item.IdMetadato ]
            .map(o => ({
              key: o[ item.KeyField || 'Key' ],
              text: o[ item.TextField || 'Text' ]
            }))
          : [];
    }

    let options: IComboBoxOption[] = [];
    if (item.Opciones) {
      options = (item.Opciones as any).map(o => ({ key: o.IdOpcionListaDesplegableMetadato, text: o.Nombre }));
    }
    return options;
  }

  private _getMetadataValues(onlyId: boolean): { [ key: string ]: any } {
    const metadata = this.state.metadata;
    const data = {};
    for (var i = 0; i < metadata.length; i++) {
      const item = metadata[ i ];
      let _value = this._values.filter(o => o.IdMetadato == item.IdMetadato)[ 0 ];
      if (_value) {
        let text = '';
        // Si el metadato es de tipo lista desplegable se debe establecer el texto de la opción seleccionada
        if (onlyId === false) {
          if (this._isComboBox(item)) {
            switch (item.IdTipoColumnaMetadato) {
              case TipoColumnaMetadato.Seleccion:
                const selectionOption = this.state.metadataOptions[ item.IdMetadato ].filter(o => o.IdOpcionListaDesplegableMetadato === _value.Valor)[ 0 ];
                text = selectionOption !== undefined ? selectionOption.Nombre : '';
                break;
              case TipoColumnaMetadato.Pais:
                const countryOption = this.state.countries.filter(o => o.countryId === _value.Valor)[ 0 ];
                text = countryOption !== undefined ? countryOption.name : '';
                break;
              case TipoColumnaMetadato.Departamento:
                const departmentOption = this.state.departments.filter(o => o.departmentId === _value.Valor)[ 0 ];
                text = departmentOption !== undefined ? departmentOption.name : '';
                break;
              case TipoColumnaMetadato.Ciudad:
                const cityOption = this.state.cities.filter(o => o.cityId === _value.Valor)[ 0 ];
                text = cityOption !== undefined ? cityOption.name : '';
                break;
              case TipoColumnaMetadato.Custom:
                const customOption = this.state.customOptions[ item.IdMetadato ].filter(o => o[ item.KeyField || 'Key' ] === _value.Valor)[ 0 ];
                text = customOption !== undefined ? customOption[ item.TextField || 'Text' ] : '';
                break;
              case TipoColumnaMetadato.CustomMultiSeleccion:
                /*const customOption = this.state.customOptions[item.IdMetadato].filter(o => o[item.KeyField || 'Key'] === _value.Valor)[0];
                text = customOption !== undefined ? customOption[item.TextField || 'Text'] : '';*/
                break;
              default:
                console.log('Falta implementación combobox', item);
                text = 'Falta implementación combobox';
                break;
            }

            data[ item.IdMetadato ] = text;
            data[ item.Codigo ] = text;

          } else {
            data[ item.IdMetadato ] = _value.Valor;
            data[ item.Codigo ] = _value.Valor;
          }
        }
        else {
          data[ item.IdMetadato ] = _value.Valor;
          data[ item.Codigo ] = _value.Valor;
        }
      } else {
        switch (item.IdTipoColumnaMetadato) {
          case TipoColumnaMetadato.Texto:
          case TipoColumnaMetadato.ExpresionRegular:
          case TipoColumnaMetadato.Numero:
          case TipoColumnaMetadato.Moneda:
          case TipoColumnaMetadato.Fecha:
          case TipoColumnaMetadato.Nota:
          case TipoColumnaMetadato.Seleccion:
          case TipoColumnaMetadato.Usuario:
          case TipoColumnaMetadato.Pais:
          case TipoColumnaMetadato.Departamento:
          case TipoColumnaMetadato.Ciudad:
          case TipoColumnaMetadato.Custom:
            data[ item.IdMetadato ] = 0;
            data[ item.Codigo ] = 0;
            break;
          case TipoColumnaMetadato.CustomMultiSeleccion:
            data[ item.IdMetadato ] = [];
            data[ item.Codigo ] = [];
            break;
          case TipoColumnaMetadato.SiNo:
            data[ item.IdMetadato ] = false;
            data[ item.Codigo ] = false;
            break;
          case TipoColumnaMetadato.Metadato:
            data[ item.IdMetadato ] = [];
            data[ item.Codigo ] = [];
            break;
        }
      }
    }
    return data;
  }

  private _isComboBox(metadata: IMetadatoAsociado): boolean {
    return metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Seleccion
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Pais
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Departamento
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Ciudad
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.TipoIdentificacion
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Custom;
  }

  private _setValue(item: IMetadatoAsociado, value: any): void {
    let _value = this._values.filter(o => o.IdMetadato == item.IdMetadato)[ 0 ];
    if (_value === undefined) {
      _value = {
        IdMetadato: item.IdMetadato,
        IdExpediente: 0,
        IdDocumentoExpediente: 0,
        IdOpcionListaDesplegableMetadato: 0,
        IdValorMetadato: 0,
        Nombre: item.Nombre,
        Codigo: item.Codigo,
        CategoriaMetadato: item.CategoriaMetadato,
        Valor: undefined
      }
      this._values.push(_value);
    }

    // Actualizar el valor
    if (value instanceof Date) {
      _value.Valor = dateToStr(value as Date);
    } else {
      _value.Valor = value;
    }

    this.setState({
      values: this._values
    });

    if (this.props.onChangeValues) {
      this.props.onChangeValues(this._values);
    }

  }

  //#endregion

  private _getColumnTypeNane(item: IMetadatoAsociado): string {
    const type = this.state.columnTypes.filter(o => o.key === Number(item.IdTipoColumnaMetadato))[ 0 ];
    if (type !== undefined) {
      return type.text;
    }
    return '';
  }

  private _renderField(item: IMetadatoAsociado): JSX.Element {

    let html: JSX.Element;
    switch (item.IdTipoColumnaMetadato) {
      case TipoColumnaMetadato.Parrafo:
        html = <div>
          {item.Nombre}
        </div >;
        break;
      case TipoColumnaMetadato.Titulo:
        html = <div>
          <h1 className='ms-font-xl ms-fontColor-themePrimary' style={{ fontWeight: 'normal' }}>{item.Nombre}</h1>
        </div >;
        break;
      default:
        html = <div className='md-Grid'>
          {
            this.props.mode === 'edit'
              ? this._renderEditFieldControl(item)
              : this._renderExecutableFieldControl(item)
          }
        </div>;
        break;
    }

    const selected = item === this.state.selectedItem;
    const className = `ms-Grid-col ${item.TamanoCompleto ? 'ms-u-sm12' : 'ms-u-sm6'}`;

    return <div className={className} style={selected ? this._fieldCss : { border: 'solid 1px transparent' }} onClick={this._fieldSelected.bind(this, item)}>
      {
        this.props.mode === 'edit'
          ? <TooltipHost
            tooltipProps={{
              onRenderContent: () => {
                return (
                  <div>
                    <ul style={{ margin: 0, padding: 0 }}>
                      <li><span className='ms-font-m ms-fontColor-themePrimary'>Categoría: </span><span>{item.CategoriaMetadato}</span></li>
                      <li><span className='ms-font-m ms-fontColor-themePrimary'>Nombre: </span><span>{item.Nombre}</span></li>
                      <li><span className='ms-font-m ms-fontColor-themePrimary'>Tipo: </span><span>{this._getColumnTypeNane(item)}</span></li>
                      <li><span className='ms-font-m ms-fontColor-themePrimary'>Pantalla completa: </span><span>{item.TamanoCompleto ? 'Si' : 'No'}</span></li>
                      {/* <li><span className='ms-font-m ms-fontColor-themePrimary'>Reglas: </span><span>{rules ? 'Si' : 'No'}</span></li> */}
                    </ul>
                  </div>
                );
              }
            }}
            directionalHint={DirectionalHint.rightCenter}>
            {
              html
            }
          </TooltipHost>
          : html
      }
      {
        this.props.mode === 'edit' && selected && <div style={{ userSelect: 'none' }}>
          <Icon
            iconName='ChromeBack'
            style={{
              ...this._addButtonStyle,
              right: '106px',
              color: item.Orden > 0 ? 'rgb(0, 120, 212)' : 'rgb(208, 200, 200)',
              border: item.Orden > 0 ? '2px solid rgb(0, 120, 212)' : '2px solid rgb(208, 200, 200)'
            }}
            onClick={this._moveLeft.bind(this, item)}
          />
          <Icon
            iconName='Delete'
            style={{
              ...this._addButtonStyle,
              right: '72px',
              color: this.state.metadata.length > 1 ? 'rgb(0, 120, 212)' : 'rgb(208, 200, 200)',
              border: this.state.metadata.length > 1 ? '2px solid rgb(0, 120, 212)' : '2px solid rgb(208, 200, 200)'
            }}
            onClick={this._removeField.bind(this, item)}
          />
          <Icon
            iconName='ChromeBackMirrored'
            style={{
              ...this._addButtonStyle,
              right: '38px',
              color: item.Orden < this.state.metadata.length - 1 ? 'rgb(0, 120, 212)' : 'rgb(208, 200, 200)',
              border: item.Orden < this.state.metadata.length - 1 ? '2px solid rgb(0, 120, 212)' : '2px solid rgb(208, 200, 200)'
            }}
            onClick={this._moveRigth.bind(this, item)}
          />
          <Icon
            iconName='Add'
            style={this._addButtonStyle}
            onClick={this._addField.bind(this, item)}
          />
        </div>
      }

    </div>

  }

  //#region Funcionalidad dinamica editor

  private _moveLeft(item: IMetadatoAsociado): void {
    const _item = this.state.metadata.filter(o => o.Orden === item.Orden)[ 0 ];
    const index = this.state.metadata.indexOf(_item);
    if (index > 0) {
      const metadata = this.state.metadata.slice();
      metadata.splice(index, 1);
      metadata.splice(index - 1, 0, _item);
      this.setState({ metadata });
    }
  }

  private _moveRigth(item: IMetadatoAsociado): void {
    const _item = this.state.metadata.filter(o => o.Orden === item.Orden)[ 0 ];
    const index = this.state.metadata.indexOf(_item);
    if (index < this.state.metadata.length - 1) {
      const metadata = this.state.metadata.slice();
      metadata.splice(index, 1);
      metadata.splice(index + 1, 0, _item);
      this.setState({ metadata });
    }
  }

  private _addField(item: IMetadatoAsociado): void {
    const _item = this.state.metadata.filter(o => o.Orden === item.Orden)[ 0 ];
    const index = this.state.metadata.indexOf(_item);
    const metadata = this.state.metadata.slice();
    metadata.splice(index + 1, 0, { ...defaultIMetadatoAsociado(), TamanoCompleto: true });
    this.setState({ metadata });
  }

  private _removeField(item: IMetadatoAsociado): void {
    if (this.state.metadata.length > 1) {
      const _item = this.state.metadata.filter(o => o.Orden === item.Orden)[ 0 ];
      const index = this.state.metadata.indexOf(_item);
      const metadata = this.state.metadata.slice();
      metadata.splice(index, 1);
      this.setState({ metadata });
    }
  }

  //#endregion Funcionalidad dinamica editor

  private _fieldSelected(selectedItem: IMetadatoAsociado): void {
    if (this.props.mode === 'edit') {
      this.setState({ selectedItem });
    }
  }

  /**
   * Retorna el siguiente elemento a renderizar
   * @param items 
   */
  private _getNextField(items: IMetadatoAsociado[]): IMetadatoAsociado {
    if (items.length > 0) {
      const item = items.splice(0, 1)[ 0 ];
      if (this.props.mode === 'exe') {
        const rules = this._contexts[ item.IdMetadato ];
        if (rules !== undefined) {
          const result = rules._show(item);
          if (result === true) {
            return item;
          }
          return this._getNextField(items);
        }
        return item;
      }
      return item;
    }
    return undefined;
  }

  private _processFields(items: IMetadatoAsociado[]): JSX.Element[] {
    const rows: JSX.Element[] = [];
    while (items.length > 0) {
      // Obtener 1 item a renderizar a la izquierda
      const leftItem = this._getNextField(items);
      if (leftItem !== undefined) {
        // Si el control es pequeño se obtiene el item a renderizar en la segunda posición si tambien es pequeño
        const rightItem = leftItem.TamanoCompleto
          ? undefined
          : items[ 0 ] !== undefined
            ? items[ 0 ].TamanoCompleto
              ? undefined
              : this._getNextField(items)
            : undefined;
        // Crear fila
        const currentRow: JSX.Element = <div className='ms-Grid-row' key={leftItem.IdMetadato}>
          {
            this._renderField(leftItem)
          }
          {
            rightItem && this._renderField(rightItem)
          }
        </div>;
        rows.push(currentRow);
      }
    }
    return rows;
  }

  /**
   * Retorna true si el metadato es requerido como resultado de la regla o como valor fijo parametrizado
   * @param item Elemento a evaluar
   */
  private _isRequired(item: IMetadatoAsociado) {
    const rules = this._contexts[ item.IdMetadato ];
    if (rules !== undefined && rules.hasRequiredRule) {
      return rules._required(item);
    }
    return item.Requerido || false;
  }

  public validate(): boolean {

    // Obtener los metadatos
    let items = this.state.metadata;
    if (items.length === 0) {
      return true;
    }

    // Filtrar elementos que no se muestran en pantalla
    items = items.filter(item => {
      const rules = this._contexts[ item.IdMetadato ];
      if (rules !== undefined) {
        return rules._show(item);
      }
      return true;
    });

    // Almacena los errores de validacióm
    const errors: { [ key: number ]: string } = {};

    for (let i = 0; i < items.length; i++) {

      const item = items[ i ];

      // Obtener el valor actual
      const value = this._getValue<any>(item);

      // Obtener campos requeridos al ejecutar regla 'requerido' o en su defecto obtener el campo 'requerido' parametrizado en el metadato
      const required = this._isRequired(item);

      if (required) {
        switch (item.IdTipoColumnaMetadato) {
          case TipoColumnaMetadato.Texto:
          case TipoColumnaMetadato.Nota:
          case TipoColumnaMetadato.ExpresionRegular:
          case TipoColumnaMetadato.Numero:
          case TipoColumnaMetadato.Moneda:
          case TipoColumnaMetadato.Fecha:
            if ($_.isNullOrEmpty(value)) {
              errors[ item.IdMetadato ] = 'Campo requerido';
              continue;
            }
            break;

          case TipoColumnaMetadato.Seleccion:
          case TipoColumnaMetadato.Usuario:
          case TipoColumnaMetadato.Pais:
          case TipoColumnaMetadato.Departamento:
          case TipoColumnaMetadato.Ciudad:
          case TipoColumnaMetadato.Custom:
            if (Number(value) <= 0) {
              errors[ item.IdMetadato ] = 'Campo requerido';
              continue;
            }
            break;

          case TipoColumnaMetadato.CustomMultiSeleccion:

            const rules = this._contexts[ item.IdMetadato ];
            if (rules !== undefined) {
              const result = rules._onValidateRequired(item);
              if (!result.isValid) {
                errors[ item.IdMetadato ] = result.message;
                continue;
              }
            }


            break;

          case TipoColumnaMetadato.Metadato:
            const rule = this._contexts[ item.IdMetadato ];
            if (rule) {
              const validationResult = rule._onValidateRequired(item);
              if (validationResult === undefined) {
                errors[ item.IdMetadato ] = 'La regla der validación no retorno una respuesta';
                continue;
              }
              if (validationResult.isValid !== true) {
                errors[ item.IdMetadato ] = validationResult.message || 'Campo requerido';
                continue;
              }
            }
            break;

          case TipoColumnaMetadato.Contactos:
          case TipoColumnaMetadato.ContactosEntidades:
          case TipoColumnaMetadato.ContactosPersonas:
            if (value <= 0) {
              errors[ item.IdMetadato ] = 'Campo requerido';
              continue;
            }
            break;

        }
      }

    }

    this.setState({
      errors
    });

    return Object.getOwnPropertyNames(errors).length === 0;
  }

}

export interface IContactosComponentProps {
  mode: 'embebed' | 'normal'
  onSelectedItem?: (contact: IContacto) => void;
  service: IService<IContacto>;
  serviceMethodName: string;
}

export interface IContactosComponentState {
  commandBar: IContextualMenuItem[];
  onSelectedItem?: (contact: IContacto) => void;
}

export class ContactosComponent extends React.Component<IContactosComponentProps, IContactosComponentState> {

  constructor(props: any) {
    super(props);
    this.state = {
      commandBar: this._buildCommandBar(undefined),
      onSelectedItem: this.props.onSelectedItem,
    };
  }

  public render(): JSX.Element {
    return <GenericDataTableComponent
      refreshOnInit={true}
      allowSearch={true}
      primaryKey='IdContacto'
      service={this.props.service}
      columnsAllowedToOrder={[
        'Nombres',
        'Activo',
        'CreadoPor',
        'FechaCreacion'
      ]}
      onSelectedRow={this._onSelectedRow.bind(this)}
      selectionMode={SelectionMode.single}
      columns={[
        {
          key: 'Nombres',
          name: 'Nombres',
          fieldName: 'Nombres',
          minWidth: 150,
          maxWidth: 250,
          isResizable: true,
          isSorted: true,
          isSortedDescending: false,
        },
        {
          key: 'Apellidos',
          name: 'Apellidos',
          fieldName: 'Apellidos',
          minWidth: 150,
          maxWidth: 250,
          isResizable: true
        },
        {
          key: 'TipoContacto',
          name: 'Tipo contacto',
          fieldName: 'TipoContacto',
          minWidth: 100,
          maxWidth: 120,
          isResizable: true
        },
        {
          key: 'TipoIdentificacion',
          name: 'Tipo identificación',
          fieldName: 'TipoIdentificacion',
          minWidth: 150,
          maxWidth: 250,
          isResizable: true
        },
        {
          key: 'Identificacion',
          name: 'Identificación',
          fieldName: 'Identificacion',
          minWidth: 100,
          maxWidth: 100,
          isResizable: false
        }
      ]}
      title={this.props.mode === 'normal' ? 'Contactos' : ''}
      searchTooltip='Busca contactos filtrando por el Nombre'
      commandBarItems={this.state.commandBar}
      paginationMethodName={this.props.serviceMethodName}
    />
  }

  private _onSelectedRow(rows: IContacto[]): void {
    this.setState({
      commandBar: this._buildCommandBar(rows[ 0 ])
    });
    if (this.props.onSelectedItem) {
      this.props.onSelectedItem(rows[ 0 ]);
    }
  }

  private _buildCommandBar(selectedItem: IContacto): IContextualMenuItem[] {
    const commandBar: IContextualMenuItem[] = [];
    if (this.props.mode === 'normal') {
      commandBar.push($_.def.btn.newButton('#' + _routes_.CREAR_CONTACTO));
      if (selectedItem) {
        commandBar.push($_.def.btn.editHref(_routes_.EDITAR_CONTACTO.replace(':id', selectedItem.IdContacto.toString())));
      }
    }
    return commandBar;
  }

  componentWillReceiveProps(nextProps: IContactosComponentProps) {
    this.setState({
      onSelectedItem: nextProps.onSelectedItem
    });
  }

}